import { BET_CONFIG } from '../config'

export const isExoticBetEnabled = (maxPickableMarbles: number): boolean => {
  return maxPickableMarbles >= BET_CONFIG.EXOTIC_BET_MIN_MARBLES
}
